

// import ReportService from "services/report-service";

// export const fetchReportData = async (selectedProfiles, fromDate, toDate, setError) => {
//   if (!selectedProfiles.length) return [];

//   try {
//     const payload = selectedProfiles.map((profile) => ({
//       profileId: profile.id,
//       platform: profile.platform,
//       fromDate: fromDate.toISOString(),
//       toDate: toDate.toISOString(),
//     }));

//     const response = await ReportService.generateCommonReports(payload);

//     // Process data for multiple profiles
//     return selectedProfiles.map((profile) => {
//       const profileData = response[profile.id] || [];

//       return {
//         profileId: profile.id,
//         platform: profile.platform,
//         label: `${profile.name}`,
//         profilePictureUrl: profile.profilePictureUrl,
//         verifiedStatus: profile.verifiedStatus,
//         link: profile.link,
//         data: profileData.map((item) => {
//           const baseData = {
//             date: item.datetime.split("T")[0],
//             // followers: item.pageMetrics?.page_follows || item.pageMetrics?.followers_count || item.pageMetrics?.predicted_followers_count || item.profileMetrics?.followers_count || item.profileMetrics?.predicted_followers_count ||  0,
//             // subscribers: item.channelMetrics?.subscribersCount || item.channelMetrics?.subscribers_count || item.channelMetrics?.predicted_subscribers_count || 0,
//             followers: item.pageMetrics?.page_follows || item.pageMetrics?.followers_count || item.profileMetrics?.followers_count ||  0,
//             subscribers: item.channelMetrics?.subscribersCount || item.channelMetrics?.subscribers_count,
//             predicted_followers: item.pageMetrics?.predicted_followers_count || item.profileMetrics?.predicted_followers_count || 0,
//             predicted_subscribers: item.channelMetrics?.predicted_subscribers_count || 0,
//           };

//           // Add platform-specific attributes
//           if (profile.platform === "YouTube") {
//             return {
//               ...baseData,
//               videos: item.videos || [], // Include the full videos array
//               videoMetrics: item.channelMetrics?.videoMetrics || {}, // Include video metrics
//             };
//           } else if (profile.platform === "Instagram") {
//             return {
//               ...baseData,
//               posts: item.posts || [], // Include the full posts array
//               profileMetrics: item.profileMetrics || {}, // Include full profile metrics
//             };
//           } else if (profile.platform === "Facebook") {
//             return {
//               ...baseData,
//               posts: item.posts || [], // Include the full posts array
//               pageMetrics: item.pageMetrics || {}, // Include full page metrics
//             };
//           }

//           return baseData; // Fallback for unknown platforms
//         }),
//       };
//     });
//   } catch (error) {
//     console.error("Error fetching report data:", error.message);
//     if (setError) setError(error.message || "Failed to fetch report data");
//     return [];
//   }
// };

// #####################################################################

import ReportService from "services/report-service";

export const fetchReportData = async (selectedProfiles, fromDate, toDate, setError) => {
  if (!selectedProfiles.length) return [];

  try {
    const payload = selectedProfiles.map((profile) => ({
      profileId: profile.id,
      platform: profile.platform,
      fromDate: fromDate.toISOString(),
      toDate: toDate.toISOString(),
    }));

    const response = await ReportService.generateCommonReports(payload);

    // Process data for multiple profiles
    return selectedProfiles.map((profile) => {
      const profileData = response[profile.id] || [];

      return {
        profileId: profile.id,
        platform: profile.platform,
        label: `${profile.name}`,
        profilePictureUrl: profile.profilePictureUrl,
        verifiedStatus: profile.verifiedStatus,
        link: profile.link,

        // ⭐ NEW: Attach the OWN status from selectedProfiles
        own: profile.own === true,

        data: profileData.map((item) => {
          const baseData = {
            date: item.datetime.split("T")[0],
            followers:
              item.pageMetrics?.page_follows ||
              item.pageMetrics?.followers_count ||
              item.profileMetrics?.followers_count ||
              0,
            subscribers:
              item.channelMetrics?.subscribersCount ||
              item.channelMetrics?.subscribers_count,
            predicted_followers:
              item.pageMetrics?.predicted_followers_count ||
              item.profileMetrics?.predicted_followers_count ||
              0,
            predicted_subscribers:
              item.channelMetrics?.predicted_subscribers_count ||
              0,
          };

          // Platform-specific
          if (profile.platform === "YouTube") {
            return {
              ...baseData,
              videos: item.videos || [],
              channelMetrics: item.channelMetrics || {}, // ✅ Include full channel metrics (contains views/impressions)
              channelDemographics: item.channelDemographics || {}, // ✅ Include demographics
              videoMetrics: item.channelMetrics?.videoMetrics || {}, // Include video metrics (if nested there)
            };
          }

          if (profile.platform === "Instagram") {
            return {
              ...baseData,
              posts: item.posts || [],
              profileMetrics: item.profileMetrics || {},
              profileDemographics: item.profileDemographics || {}, // ✅ Added missing field
            };
          }

          if (profile.platform === "Facebook") {
            return {
              ...baseData,
              posts: item.posts || [],
              pageMetrics: item.pageMetrics || {},
              pageDemographics: item.pageDemographics || {}, // ✅ Added missing field
            };
          }

          return baseData;
        }),
      };
    });
  } catch (error) {
    console.error("Error fetching report data:", error.message);
    if (setError) setError(error.message || "Failed to fetch report data");
    return [];
  }
};
